import { render, staticRenderFns } from "./MessageMemberLeft.vue?vue&type=template&id=36a48b49&"
import script from "./MessageMemberLeft.vue?vue&type=script&lang=js&"
export * from "./MessageMemberLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports